import React, { useState } from 'react';
import './App.css';

const LOGO_URL = 'https://storage.googleapis.com/mhp-media/img/8bf03907-8ab3-49ee-949c-ba1eb8e05b06.png';

const menuItems = [
  { name: 'Mini Palak Medhu Vadai', category: 'starters' },
  { name: 'Beetroot Poori', category: 'rice' },
  { name: 'Seeragasamba Kuska', category: 'rice' },
  { name: 'Steamed Rice', category: 'rice' },
  { name: 'Kathrikai Murungakai Manga Sambar', category: 'gravy' },
  { name: 'Pineapple Rasam', category: 'gravy' },
  { name: 'Cauliflower Soya Jeeraga Kuzhambu', category: 'gravy' },
  { name: 'Parupu Urundai Moor Kuzhambu', category: 'gravy' },
  { name: 'Nookal Pattani Kurma', category: 'gravy' },
  { name: 'Mango Sweet Pachadi', category: 'sides' },
  { name: 'Vellai Poosani Pal Kootu', category: 'sides' },
  { name: 'Kothavaraga Thovatel', category: 'sides' },
  { name: 'Siru Urulai Melagu Roast', category: 'sides' },
  { name: 'Tindora Peanut Podi Mass', category: 'sides' },
  { name: 'Malli Thovaiyal', category: 'sides' },
  { name: 'Mini Adhirasam', category: 'sweets' },
  { name: 'Mixed Dry Fruit Laddu', category: 'sweets' },
  { name: 'Payaru Semiya Payasam', category: 'sweets' },
  { name: 'Yogurt', category: 'extras' },
  { name: 'Vadaams', category: 'extras' },
  { name: 'Baby Banana', category: 'extras' },
  { name: 'Sweet Paan Beeda', category: 'extras' },
  { name: 'Paruppu Podi / Peanut Podi / Ghee / Pickle', category: 'extras' },
];

const categoryLabels = {
  starters: { label: 'Starters', icon: '🍘' },
  sweets: { label: 'Sweets & Desserts', icon: '🍯' },
  rice: { label: 'Rice & Breads', icon: '🍚' },
  gravy: { label: 'Festival Special Curries', icon: '🍲' },
  sides: { label: 'Side Dishes', icon: '🥘' },
  extras: { label: 'Accompaniments', icon: '🥄' },
};

const outlets = [
  { name: 'Princeton', state: 'NJ', link: 'https://www.order.a2bnewjersey.com/restaurant/a2b-princeton/menu/Pickup/event/tamil-newyear-2026' },
  { name: 'South Plainfield', state: 'NJ', link: 'https://www.order.a2bnewjersey.com/restaurant/a2b-south-plainfield/menu/Pickup/event/tamil-newyear-2026' },
  { name: 'Parsippany', state: 'NJ', link: 'https://www.order.a2bnewjersey.com/restaurant/a2b-parsippany/menu/Pickup/event/tamil-newyear-2026' },
  { name: 'Northborough', state: 'MA', link: 'https://order.a2bma.com/restaurant/a2b-northborough/menu/Pickup/event/tamil-newyear-2026/' },
  { name: 'Warrenville', state: 'IL', link: 'https://www.order.a2billinois.com/restaurant/a2b-chicago/menu/Pickup/event/tamil-newyear-2026' },
];

function App() {
  const [selectedOutlet, setSelectedOutlet] = useState(null);

  const scrollToOutlets = () => {
    document.getElementById('outlets')?.scrollIntoView({ behavior: 'smooth' });
  };

  const categories = ['starters', 'rice', 'gravy', 'sides', 'sweets', 'extras'];

  return (
    <div className="App">
      <div className="kolam-border-top"></div>

      {/* Hero Section - Full Viewport */}
      <header className="hero">
        {/* Kolam dot pattern overlay */}
        <div className="kolam-pattern"></div>

        {/* Top swooping marigold garland with center mango leaf */}
        <div className="garland-top-wrap">
          <div className="garland-swoop garland-swoop-left"></div>
          <div className="garland-center-leaf"></div>
          <div className="garland-swoop garland-swoop-right"></div>
        </div>

        {/* Left vertical flower garland */}
        <div className="vertical-garland vertical-garland-left">
          {[...Array(18)].map((_, i) => (
            <div key={i} className={`garland-flower ${i % 3 === 0 ? 'gf-orange' : i % 3 === 1 ? 'gf-yellow' : 'gf-leaf'}`}></div>
          ))}
        </div>

        {/* Right vertical flower garland */}
        <div className="vertical-garland vertical-garland-right">
          {[...Array(18)].map((_, i) => (
            <div key={i} className={`garland-flower ${i % 3 === 0 ? 'gf-yellow' : i % 3 === 1 ? 'gf-orange' : 'gf-leaf'}`}></div>
          ))}
        </div>

        {/* Hanging bead chains with diyas */}
        <div className="hanging-chains">
          <div className="bead-chain bc-1">
            <div className="beads"></div>
            <div className="chain-diya"></div>
          </div>
          <div className="bead-chain bc-2">
            <div className="beads"></div>
            <div className="chain-diya"></div>
          </div>
          <div className="bead-chain bc-3">
            <div className="beads"></div>
            <div className="chain-diya"></div>
          </div>
        </div>

        <div className="hero-content">
          <img src={LOGO_URL} alt="A2B Restaurant" className="logo" />
          <div className="title-section">
            <h1 className="main-title">Chithirai Thiruvizha Virundhu</h1>
            <div className="title-divider">
              <span className="divider-ornament">✦</span>
              <span className="divider-line"></span>
              <span className="divider-text">Tamil New Year Special Feast</span>
              <span className="divider-line"></span>
              <span className="divider-ornament">✦</span>
            </div>
            <div className="preorder-closed-banner">
              <span className="closed-icon"></span>
              <p className="closed-text">Pre-ordering is now closed</p>
              <p className="closed-subtext">Thank you for your overwhelming response!</p>
            </div>
            <p className="hero-closing">
              Wishing you abundance, joy, and a delicious celebration. Iniya Chithirai Puthandu Nalvaazhthukkal! 🪔✨
            </p>
          </div>
        </div>
        <div className="hero-wave">
          <svg viewBox="0 0 1440 120" preserveAspectRatio="none">
            <path d="M0,60 C360,120 720,0 1080,60 C1260,90 1380,80 1440,60 L1440,120 L0,120 Z" fill="#F5EDE4"/>
          </svg>
        </div>
      </header>

      {/* Menu and Outlets sections removed - preorder closed */}

      {/* Footer */}
      <footer className="footer">
        <div className="footer-content">
          <img src={LOGO_URL} alt="A2B" className="footer-logo" />
          <p className="footer-tagline">Authentic South Indian Vegetarian Cuisine</p>
          <div className="footer-divider"></div>
          <p className="footer-copy">
            புத்தாண்டு வாழ்த்துகள் &bull; Happy Tamil New Year 2026
          </p>
        </div>
      </footer>
    </div>
  );
}

export default App;
